export enum ROLE {
    Guest = "guest",
    Customer = "customer",
}
